<template lang="html">
    <section class="form pa-5">
        <h1>שלח התראה</h1>
        <h3>אפליקציה - {{ app }}</h3>
        <v-form ref="notification" v-model="valid" lazy-validation>
            <v-text-field prepend-icon="mdi-format-title" counter maxlength="40" v-model="notification.title" label="כותרת"></v-text-field>
    
            <v-textarea prepend-icon="mdi-subtitles" v-model="notification.body" label="תוכן" required :rules="requireRule" :maxlength='notification.title ? "90":"178"' counter rows="3"></v-textarea>
    
            <v-text-field prepend-icon="mdi-link" v-model="notification.image" label="לינק לתמונה" :rules="imageRule" type=""></v-text-field>
    
            <v-autocomplete :disabled="segmentsDisabled" prepend-icon="mdi-account-group" chips clearable deletable-chips multiple v-model="notification.segment" :rules="requireRule" :items="segments" item-text="name" label="קבוצות"></v-autocomplete>
            <v-row>
                <v-col cols="10">
                    <v-text-field prepend-icon="mdi-web" disabled v-model="notification.deeplink && notification.deeplink.label" label="קישור DeepLink"></v-text-field>
                </v-col>
                
                <v-btn color="primary" height="60px" dark @click.stop="buildLinkOpen.open = true">
                    Build Link
                </v-btn>
                <BuildLink :open="buildLinkOpen" v-model="notification.deeplink" />
                 <v-col cols="12">
                    <v-text-field prepend-icon="mdi-web" disabled v-model="notification.deeplink && notification.deeplink.link" label="קישור DeepLink"></v-text-field>
                </v-col>
            </v-row>
    
            <v-checkbox prepend-icon="mdi-volume-high" v-model="notification.sound" label="צליל"></v-checkbox>
            <!--
            <v-autocomplete prepend-icon="mdi-shape" v-model="notification.theme" :items="segments" label="תבנית"></v-autocomplete>
    
    
            <v-text-field prepend-icon="mdi-map-marker" v-model="notification.location" label="מיקום"></v-text-field>
    
            <v-autocomplete prepend-icon="mdi-alarm" v-model="notification.schedule" :items="segments" label="תזמון"></v-autocomplete>
    -->
            <v-btn small class="mr-4" @click="cancelDialog = true" color="error">
                <v-icon>mdi-delete</v-icon>
            </v-btn>

            <v-btn small :disabled="!valid" class="mr-4" @click="testDialog = true">
                שלח TEST
            </v-btn>
    
            <v-btn small :disabled="!valid" class="mr-4" @click="send('draft')">
                שמור כטיוטה
            </v-btn>
    
            <v-btn large :disabled="!valid" color="success" class="mr-4" @click="openDialog">
                שלח
            </v-btn>

            
    
        </v-form>
         <v-dialog v-model="testDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    שליחת טסט
                </v-card-title>

                <v-card-text> 
                    <v-combobox prepend-icon="mdi-cellphone"  item-value="token" v-model="notification.token" :rules="requireRule" :items="testDevices" item-text="name" label="בחר מכשיר"></v-combobox>
                </v-card-text>
        
                <v-card-actions>
                    <v-spacer></v-spacer>
    
                    <v-btn color="green darken-1" text @click="testDialog = false">
                        עוד לא
                    </v-btn>
    
                    <v-btn color="green darken-1" @click="testDialog = false; send('test')">
                        שלח
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    אישור שליחה
                </v-card-title>
    
                <v-card-text>
                    האם לשלוח את ההתראה לכל משתמשי האפליקציה?
                </v-card-text>
    
                <v-card-actions>
                    <v-spacer></v-spacer>
    
                    <v-btn color="green darken-1" text @click="dialog = false">
                        עוד לא
                    </v-btn>
    
                    <v-btn color="green darken-1" @click="dialog = false; send('all')">
                        שלח
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
         <v-dialog v-model="cancelDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    מחיקת פוש
                </v-card-title>
    
                <v-card-text>
                    האם לבטל\למחוק את הפוש? 
                </v-card-text>
    
                <v-card-actions>
                    <v-spacer></v-spacer>
    
                    <v-btn  text @click="cancelDialog = false">
                        לא
                    </v-btn>
    
                    <v-btn  @click="trash" color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>

<script lang="js">
import firebase from "firebase/app";
import "firebase/auth";

import BuildLink from '@/components/buildLink.vue'
export default {
    name: 'notify-form',
    props: [],
    components: {
        BuildLink
    },
    mounted() {
        this.$store.commit('setNotification')
        const params = new URLSearchParams(location.search)

        let template = params.get("template")
        if (template) {
            this.$store.commit('setNotification', template)
            if (params.get("copy")) {
                this.notification.id = null
                this.notification.sentData = null
                this.notification.messageId = null
            }
        }
        switch (this.app) {
            case 'kan':
                this.segmentsDisabled = false
                break;

            case 'hinuchit':
                this.notification.segment = ['hinuchitMain']
                break;

            case 'stickers':
                this.notification.segment = ['stickersMain']
                break;
        }
        this.notification.segment ||= this.segments.includes("news") ? ["news"] : []
    },
    data() {
        return {
            dialog: false,
            buildLinkOpen: {
                open: false
            },
            cancelDialog: false,
            testDialog: false,
            segmentsDisabled: true,
            valid: true,
            requireRule: [
                v => !!v || "שדה זה חובה"
            ],
            imageRule: [
                // v => !v || v.includes("A.") || "הסיומת צריכה להיות A, לדוגמה: imgid=46494_A.jpeg",
                // v => !v || !this.notification.imageAspectRatio || this.notification.imageAspectRatio.toFixed(2) == (9 / 16).toFixed(2) || "התמונה צריכה להיות 16:9"
            ],
        }
    },
    methods: {
        openDialog() {
            if (this.$refs.notification.validate()) {
                this.dialog = true
            }
        },
        send(type) {
            if (this.$refs.notification.validate()) {
                this.notification.type = type
                this.notification.status = type == "draft" ? "נוצר" : "בשליחה"
                this.notification.app = this.app
                this.$store.dispatch('sendPush')
                this.$router.push(`/history/${this.app}`)
            }
        },
        trash() {
            this.cancelDialog = false; 
            this.$router.go(-1)
            this.$store.dispatch('deleteNotify', this.notification.id)
        }
    },
    computed: {
        notification() {
            return this.$store.getters.notification
        },
        app() {
            return this.$route.params.app
        },
        segments() {
            const segs = this.$store.getters.userClaims.segments
             switch (this.app) {
            case 'kan':
                return segs.filter(x => x != 'hinuchitMain' && x != 'stickersMain')

            case 'hinuchit':
                return ['hinuchitMain']

            case 'stickers':
                return ['stickersMain']
         }

        } ,

        testDevices() {
            return this.$store.getters.testDevices
        }

    },
    watch: {
        'notification.imageAspectRatio' (newValue, oldValue) {
            this.$refs.notification.validate()
        }
    }
}
</script>

<style lang="scss" scoped>
.form {}
</style>
